module.exports = __webpack_public_path__ + "static/img/12bg_2.c6a801a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/12bg_2.png
// module id = 641
// module chunks = 1